import type { ExtractPublicPropTypes, PropType } from 'vue'

export const sidebarPanelProps = {
  visible: { type: Boolean, default: false },
  title: { type: String, default: null },
  subtitle: { type: String, default: null },
  description: { type: String, default: null },
  icon: { type: String, default: null },
  headerStyle: { type: String as PropType<'brand' | 'dark' | 'author' | 'complaince' | 'helpSupportAssistant' | 'report' | 'callAssistantModal'|  'readCallAssistant' | 'feedbackAssistant' | 'print' | 'feedback' | 'slideshow' | 'notification' | 'slideshowEdit' | 'slideshowEditFull'| 'lngReviewEdit'>, default: 'brand' },
  position: { type: String as PropType<'left' | 'right'>, default: 'right' },
  modal: { type: Boolean, default: false },
  size: { type: String as PropType<'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full' | 'lngReviewEdit'>, default: 'md' },
  compactContent: { type: Boolean, default: false },
  dismissable: { type: Boolean, default: true },
  empty: { type: Boolean, default: false },
  refreshOnClose: { type: Boolean, default: false }
}

export type SidebarPanelProps = ExtractPublicPropTypes<typeof sidebarPanelProps>

export interface SidebarPanelEmits {
  (e: 'update:visible', value: boolean): void
}
